import "../../App.css";
import React from 'react';
import DesignItems from "../../DesignItems";

function Designs() {
  return (
    <>
    <DesignItems />
    </>
  );
}

export default Designs;
